export default "__VITE_ASSET__42aaaa90__"